import styled from 'styled-components';
import Icon from 'js/components/common/Icon';

export default styled(Icon).attrs(({ direction }) => ({
  name: `chevron-${direction}`,
}))`
  justify-self: center;
  align-self: center;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  color: ${({ disabled }) => (disabled ? '#aaa' : '#666')};
  font-size: 1.2rem;

  &:hover {
    color: ${({ disabled }) => (disabled ? '#aaa' : 'black')};
  }
`;
